export interface ICommand { }

export class ClearPhasesCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.ClearPhasesCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.ClearPhasesCommandV1, TCh.Domain.Quest'
	}

}

export class CloneProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.CloneProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	SourcePlanId: string
	ClonePlanName: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, sourcePlanId: string, clonePlanName: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.SourcePlanId = sourcePlanId
		this.ClonePlanName = clonePlanName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.CloneProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class CreateProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.CreateProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	PlanName: string
	DurationInMonths: number
	Granularity: any
	Denomination: any
	SubmissionDueDateIsoString: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, planName: string, durationInMonths: number, granularity: any, denomination: any, submissionDueDateIsoString: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.PlanName = planName
		this.DurationInMonths = durationInMonths
		this.Granularity = granularity
		this.Denomination = denomination
		this.SubmissionDueDateIsoString = submissionDueDateIsoString
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.CreateProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class CreateProjectCapexItemCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.CreateProjectCapexItemCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	ItemId: string
	CapexAccountId: string
	Name: string
	Cost: number
	AcquisitionMonthIndex: number
	SalvageValue: number | null
	UsefulLifeInYears: number | null
	DepreciationMethod: any
	Denomination: any

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, itemId: string, capexAccountId: string, name: string, cost: number, acquisitionMonthIndex: number, salvageValue: number | null, usefulLifeInYears: number | null, depreciationMethod: any, denomination: any)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.ItemId = itemId
		this.CapexAccountId = capexAccountId
		this.Name = name
		this.Cost = cost
		this.AcquisitionMonthIndex = acquisitionMonthIndex
		this.SalvageValue = salvageValue
		this.UsefulLifeInYears = usefulLifeInYears
		this.DepreciationMethod = depreciationMethod
		this.Denomination = denomination
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.CreateProjectCapexItemCommandV1, TCh.Domain.Quest'
	}

}

export class CreatePlanFromTemplateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.CreatePlanFromTemplateCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	PlanName: string
	ProjectPlanTemplateId: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, planName: string, projectPlanTemplateId: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.PlanName = planName
		this.ProjectPlanTemplateId = projectPlanTemplateId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.CreatePlanFromTemplateCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteProjectCapexItemCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.DeleteProjectCapexItemCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	ItemId: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, itemId: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.ItemId = itemId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.DeleteProjectCapexItemCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.DeleteProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.DeleteProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class ExportProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.ExportProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.ExportProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class SetPhaseDurationCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.SetPhaseDurationCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	ProjectPhaseDefinitionId: string
	DurationInMonths: number

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, projectPhaseDefinitionId: string, durationInMonths: number)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.ProjectPhaseDefinitionId = projectPhaseDefinitionId
		this.DurationInMonths = durationInMonths
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.SetPhaseDurationCommandV1, TCh.Domain.Quest'
	}

}

export class SetupPhasesCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.SetupPhasesCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	PhaseDurations: any

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, phaseDurations: any)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.PhaseDurations = phaseDurations
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.SetupPhasesCommandV1, TCh.Domain.Quest'
	}

}

export class SubmitProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.SubmitProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.SubmitProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class UnsubmitProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UnsubmitProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UnsubmitProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateBenefitsConfidenceFactorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateBenefitsConfidenceFactorCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	BenefitsConfidenceFactor: number | null

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, benefitsConfidenceFactor: number | null)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.BenefitsConfidenceFactor = benefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateBenefitsConfidenceFactorCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectCapexItemCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectCapexItemCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	ItemId: string
	CapexAccountId: string
	Name: string
	Cost: number
	AcquisitionMonthIndex: number
	SalvageValue: number | null
	UsefulLifeInYears: number | null
	DepreciationMethod: any
	Denomination: any

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, itemId: string, capexAccountId: string, name: string, cost: number, acquisitionMonthIndex: number, salvageValue: number | null, usefulLifeInYears: number | null, depreciationMethod: any, denomination: any)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.ItemId = itemId
		this.CapexAccountId = capexAccountId
		this.Name = name
		this.Cost = cost
		this.AcquisitionMonthIndex = acquisitionMonthIndex
		this.SalvageValue = salvageValue
		this.UsefulLifeInYears = usefulLifeInYears
		this.DepreciationMethod = depreciationMethod
		this.Denomination = denomination
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectCapexItemCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectExpenseAllocationsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectExpenseAllocationsCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	Granularity: any | null
	Denomination: any
	Entries: any
	Comment: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, granularity: any | null, denomination: any, entries: any, comment: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.Granularity = granularity
		this.Denomination = denomination
		this.Entries = entries
		this.Comment = comment
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectExpenseAllocationsCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectExpenseSavingsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectExpenseSavingsCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	Granularity: any | null
	Denomination: any
	Entries: any
	Comment: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, granularity: any | null, denomination: any, entries: any, comment: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.Granularity = granularity
		this.Denomination = denomination
		this.Entries = entries
		this.Comment = comment
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectExpenseSavingsCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectMarginsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectMarginsCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	Granularity: any | null
	Entries: any
	Comment: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, granularity: any | null, entries: any, comment: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.Granularity = granularity
		this.Entries = entries
		this.Comment = comment
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectMarginsCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	PlanName: string
	DurationInMonths: number
	Granularity: any
	Denomination: any
	SubmissionDueDateIsoString: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, planName: string, durationInMonths: number, granularity: any, denomination: any, submissionDueDateIsoString: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.PlanName = planName
		this.DurationInMonths = durationInMonths
		this.Granularity = granularity
		this.Denomination = denomination
		this.SubmissionDueDateIsoString = submissionDueDateIsoString
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectResourceAllocationsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectResourceAllocationsCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	Granularity: any | null
	Entries: any
	Comment: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, granularity: any | null, entries: any, comment: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.Granularity = granularity
		this.Entries = entries
		this.Comment = comment
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectResourceAllocationsCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectResourceSavingsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectResourceSavingsCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	Granularity: any | null
	Entries: any
	Comment: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, granularity: any | null, entries: any, comment: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.Granularity = granularity
		this.Entries = entries
		this.Comment = comment
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectResourceSavingsCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectResourceUnitCostsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectResourceUnitCostsCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	FromYear: number
	Entries: any
	Comment: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, fromYear: number, entries: any, comment: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.FromYear = fromYear
		this.Entries = entries
		this.Comment = comment
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectResourceUnitCostsCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectRevenuesCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectRevenuesCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	Id: string
	Granularity: any | null
	Denomination: any
	Entries: any
	Comment: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, id: string, granularity: any | null, denomination: any, entries: any, comment: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.Id = id
		this.Granularity = granularity
		this.Denomination = denomination
		this.Entries = entries
		this.Comment = comment
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlans.Commands.UpdateProjectRevenuesCommandV1, TCh.Domain.Quest'
	}

}

